import { render, staticRenderFns } from "./SeverityChip.vue?vue&type=template&id=77104b67&scoped=true&"
import script from "./SeverityChip.vue?vue&type=script&lang=js&"
export * from "./SeverityChip.vue?vue&type=script&lang=js&"
import style0 from "./SeverityChip.vue?vue&type=style&index=0&id=77104b67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77104b67",
  null
  
)

export default component.exports